const ExtEsp = {

    init: function () {
        const button = $("#button-esp-check");
        if (button.length) {
            button
                .off("click")
                .on("click", function(e) {
                        e.preventDefault();
                        $("#button-esp-check").prop("disabled", true).attr("disabled", true);
                        ExtEsp.vyhledejSubjekt(false);
                    }
                );
        }
    },

    vyhledejSubjekt: function(agendio) {
        const sectionId = $("#idSection").val();
        const itemId = $("#idItem").val();
        const _ch = $("#_ch").val();

        let url = window.location.protocol + "//" + window.location.host;
        url += "/ext-esp/vyhledej-subjekt";

        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            global: true,
            data: { "_ch": _ch, "sectionId": sectionId, "itemId": itemId },
            beforeSend: function() {
                Lemo_Alert.addInfo("Esp - ověřuji subjekt", "espCheckBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("espCheckBeforeSend");
                $("#button-esp-check").prop("disabled", false).attr("disabled", false);
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }
                if (r.hasOwnProperty("status") && true !== r["status"]) {
                    return;
                }

                let espId = null;
                if (r.hasOwnProperty("data")) {
                    const data = r.data;
                    if (data.hasOwnProperty("espId") && data["espId"]) {
                        espId = data["espId"];
                        $("#idesp").val(espId);
                    } else {
                        $("#idesp").val("");
                    }
                }

                // zalozeni subjektu
                if (null === espId) {
                    ExtEsp.aktualizujSubjekt(null, agendio);
                    return;
                }

                // zobrazeni zmen
                if (true === r.hasOwnProperty("html") && null !== r["html"]) {
                    Lemo_Modal.setTitle("ESP - údaje k aktualizaci");
                    Lemo_Modal.setSize("large");
                    Lemo_Modal.setContent(r["html"]);
                    Lemo_Modal.addButton("update", translate("Aktualizovat"), "btn btn-primary", function() {
                        ExtEsp.aktualizujSubjekt(espId, agendio);
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.addButton("cancel", "Cancel", "btn btn-default", function() {
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build();
                } else if (true === agendio) {
                    Plugin_Agendio.update();
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Ověření subjektu selhalo ...", "espCheckError");
            }
        });
    },

    aktualizujSubjekt: function(espId, agendio) {
        const sectionId = $("#idSection").val();
        const itemId = $("#idItem").val();
        const _ch = $("#_ch").val();

        let url = window.location.protocol + "//" + window.location.host;
        let info = "Esp - aktualizuji subjekt";
        if (null === espId) {
            info = "Esp - zakládám nový subjekt";
            url += "/ext-esp/zaloz-subjekt";
        } else {
            url += "/ext-esp/aktualizuj-subjekt";
        }

        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            global: true,
            data: { "_ch": _ch, "espId": espId, "sectionId": sectionId, "itemId": itemId },
            beforeSend: function() {
                Lemo_Alert.addInfo(info, "espUpdateBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("espUpdateBeforeSend");
                $("#button-esp-check").prop("disabled", false).attr("disabled", false);
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r["messages"]);
                }

                if (true === agendio) {
                    if (r.hasOwnProperty("status") && true === r.status) {
                        Lemo_Alert.addInfo("Pro odeslání do Agendio stiskněte opětovně tlačítko.", "espAgendiClickMore");
                    } else {
                        Lemo_Alert.addDanger("Nepodařilo se založit subjekt, nelze odesílat do Agendio.", "espUpdateError");
                    }
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Aktualizace subjektu selhala ...", "espUpdateError");
            }
        });
    },
};

$(document).ready(function() {
    ExtEsp.init();
});

